import type { AddToWishlistEventItem } from './eCommerceTrackingEventSchema';
import type { ListAttribution } from './trackWishlistsActions';
import type { WishlistTrackingProduct } from './productsToAnalyticsItemConverter';
import { buildBaseTrackingItem } from './buildBaseTrackingItem';

export const convertAnalyticsProductToWishlistItem = (
  product: WishlistTrackingProduct,
  listAttribution: ListAttribution | undefined,
  country: string,
  preOrderEnabled: boolean,
  pricesIncludeTax: boolean
): AddToWishlistEventItem => {
  const {
    code,
    name,
    brand,
    currentPrice,
    campaignPrice,
    strikePrice,
    recommendedRetailPrice,
    categoryWithParents,
    badges = null,
    stockLevelIndication,
    preOrderSettings = null
  } = product;

  const categoryNames: ReadonlyArray<string> = categoryWithParents.map(({ name }): string => name);
  const listContext = listAttribution
    ? {
        originId: listAttribution.itemListId,
        originType: listAttribution.itemListName
      }
    : undefined;

  const item = buildBaseTrackingItem({
    id: code,
    name,
    brandName: brand?.name ?? null,
    categoryNames,
    listContext,
    badges,
    stockLevelIndication,
    preOrderSettings,
    preOrderEnabled,
    pricesIncludeTax,
    country,
    price: currentPrice.valueWithoutTax,
    prices: {
      currentPrice,
      campaignPrice,
      strikePrice,
      recommendedRetailPrice
    }
  });

  return {
    ...item,
    index: product.index ?? 0,
    quantity: 1
  };
};
